





import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Noschedule extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/catalog/card/components/tabs/schedule/components/noschedule/Noschedule.vue